<ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>
<alert></alert>
<div class="people-background">
  <div class="muted" style="float:right">{{version}}</div>
  <div class="outer">
    <div class="middle">
      <div class="inner" style="width:400px; /*background-color: transparent; padding:20px; font-size:16px;*/ ">
        <ng-template [ngIf]="!uiService.displayOtherLoginLogo"><div style="text-align: center; padding-bottom: 10px;" (click)="onMeasureSpeed($event)">
          <img src="assets/img/logo-emprez-bleu-stone.png" style="width:300px;vertical-align: middle;" class="img-responsive" alt="Login Form" />
        </div></ng-template>
        <ng-template [ngIf]="uiService.displayOtherLoginLogo"><div style="text-align: center;" (click)="onMeasureSpeed($event)">
          <img [src]="uiService.uiConfiguration.otherLoginLogoUrl" style="width:300px;margin-top: 5px;" class="img-responsive" alt="Login Form" />
        </div></ng-template>
        <!--<div style="margin-top: 10px;">&nbsp;</div>-->

        <ng-template [ngIf]="uiService.uiConfiguration?.displayLoginSubTitle"><div style="margin-bottom: 10px; text-align: center; font-size: smaller">
          {{uiService.uiConfiguration.loginSubTitleContent | translate}}
        </div></ng-template>

        <!--
        <div class="blockquote">
          <p *ngIf="isFrench()">Attention: Le 1er août 2018, nous effectuerons une mise à jour matérielle.<br><b>Emprez sera indisponible du 1er août 2018 23:00 EST au 2 août 2018 03:00 EST</b><br>
            Merci de votre compréhension.<br><br></p>
          <p *ngIf="!isFrench()">  Please note: On Aug. 1st 2018, we will upgrade the main servers.<br><b>
              Emprez won't be available from Aug. 1st 2018 23:00 EST to Aug. 2nd 2018 03:00 EST.</b><br>
        Thank you for your understanding.<br><br></p>

        </div>
        -->
        <div class="panel-body">
          <form accept-charset="UTF-8" role="form" class="form-signin">
            <fieldset>
              <!--<label class="panel-login">-->
                <!--<div class="login_result">{{resultMessage}}</div>-->
              <!--</label>-->
              <input class="form-control" placeholder="{{'Username' | translate}}" [focus]="focusUsername" [(ngModel)]="info.username" name="bidule" type="text">
              <div style="margin-top: 0px;">&nbsp;</div>

                <div class="input-group">
                    <input class="form-control" placeholder="{{'Password' | translate}}" [focus]="focusPassword" [(ngModel)]="info.pwd"
                           name="bidule2" [type]="showPassword ? 'text' : 'password'" >
                    <button class="input-group-addon" (click)="showPassword = !showPassword" type="button">
                        <ng-template [ngIf]="!showPassword"><i class="emprez-duo-icon fad fa-eye"></i></ng-template>
                        <ng-template [ngIf]="showPassword"><i class="emprez-duo-icon fad fa-eye-slash"></i></ng-template>
                    </button>
                </div>
<!--              <input class="form-control" placeholder="{{'Password' | translate}}" [focus]="focusPassword" [(ngModel)]="info.pwd"  name="bidule2" type="password">-->
              <div style="margin-top: 0px;">&nbsp;</div>
              <div class="form-check horarius-blue" style="display:inline;font-size: smaller; font-weight: 100; float:left;">
                <label class="form-check-label">
                  <input type="checkbox" name="rememberMe" class="form-check-input" [(ngModel)]="rememberMe">
                  {{'Remember me' | translate}}
                </label>
              </div>
              <div class="form-check"  style="display:inline; float:right; font-size: smaller; font-weight: 100;">
                <a class="naked" (click)="onPasswordReminder($event)" >{{'Forgot Password?' | translate}}</a>
              </div>

              <ng-template [ngIf]="uiService.uiConfiguration?.displayEmprezInfo"><div  style="margin-top: 20px;">&nbsp;</div></ng-template>
              <!--
              <a  *ngIf="uiService.uiConfiguration?.displayEmprezInfo" class="naked emprez-vert-agrume" style="font-size: larger; text-align: center " target="_blank" href="https://emprez-posologic.wistia.com/medias/3ng09ooykf?wvideo=3ng09ooykf">
                <i class="fa fa-spin fa-play-circle-o emprez-orange-fiesta fa-1x"></i>&nbsp;Découvrez la nouvelle interface!</a>
              -->
              <div style="margin-top: 10px;">&nbsp;</div>
              <button class="btn btn-lg btn-success btn-block" (click)="onLogin()" >{{'Login' | translate}}&nbsp;<i class="fa fa-sign-in fa-1x"></i></button>


<!--                <button class="btn btn-lg btn-success btn-block" (click)="onLoginOpenId()" >{{'Login - OpenID' | translate}}&nbsp;<i class="fa fa-sign-in fa-1x"></i></button>-->
<!---->
            </fieldset>
          </form>
          <!--{{resultMessage}}-->

        </div>
      </div>
    </div>
  </div>


</div>
